import { createAction } from '/@/store/utils';

export const isOnline = createAction('NETWORK:ONLINE');
export const isOffline = createAction('NETWORK:OFFLINE');
